import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Button, mainTheme } from '@plecto/ui';

const StyledDropdownFooter = styled.div`
  padding: 8px 8px 4px;
  margin-top: 4px;
  display: flex;
  justify-content: space-between;
  gap: 4px;
  align-items: center;
  border-top: 1px solid ${mainTheme.border.decorative};
`;

type FilterDropdownMenuFooterProps = {
	disabled: boolean;
	onSave: () => void;
	onCancel: () => void;
}

export function FilterDropdownMenuFooter({
	disabled,
	onSave,
	onCancel,
}: FilterDropdownMenuFooterProps) {
	const { t } = useTranslation();
	return <StyledDropdownFooter>
		<Button
			variant={'white'}
			size={'small'}
			disabled={disabled}
			label={t('Clear filters')}
			onClick={onCancel}
		/>
		<Button
			variant={'primary'}
			size={'small'}
			disabled={disabled}
			label={t('Apply')}
			onClick={onSave}
		/>
	</StyledDropdownFooter>;

}
